import { type Directive, nextTick, watch } from "vue"
import { useUserStoreHook } from "@/store/modules/user"

/** 权限指令 */
export const permission: Directive = {
  mounted(el, binding) {
    const userStore = useUserStoreHook()
    const comment = document.createComment(" v-permission 占位符 ")
    let hasPermission = false

    const updateVisibility = async () => {
      const { value } = binding
      if (value) {
        const permissions = value
        hasPermission = userStore.checkPermission(permissions)
        await nextTick()
        if (!hasPermission && el.parentNode) {
          el.parentNode.replaceChild(comment, el)
        } else if (hasPermission && comment.parentNode) {
          comment.parentNode.replaceChild(el, comment)
        }
      } else {
        throw new Error(
          `需要权限！例如 v-permission="['business','business_booking']" 或 v-permission="'business_booking'"`,
        )
      }
    }

    // 初始检查
    updateVisibility()

    // 监听权限变化
    const stopWatch = watch(() => userStore.getActivePermissionList(), updateVisibility, { deep: true })

    // 存储清理函数
    el._permissionDirectiveCleanup = () => {
      stopWatch()
      if (!hasPermission && comment.parentNode) {
        comment.parentNode.replaceChild(el, comment)
      }
    }
  },
  unmounted(el) {
    // 清理 watch 和恢复原始元素
    if (el._permissionDirectiveCleanup) {
      el._permissionDirectiveCleanup()
    }
  },
}
